.paragraph {
  margin: 0;
}

.office {
  margin: 16px 0;
}

.caption {
  color: var(--black-at-75);
}
